import styled from 'styled-components'
import { OverlayHover } from '../../components/PageBuilderSection/styles'

export const CardWrapper = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  max-width: 1920px;
  width: 100%;
  height: 100%;
  min-height: 360px;
  aspect-ratio: 16/9;

  ${({ theme }) => '@media ' + theme.mediaQueries.mobile} {
    min-height: 350px;
  }

  ${({ theme }) => '@media ' + theme.mediaQueries.sm} {
    min-height: 290px;
  }
`

export const CardContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  ${OverlayHover}
`

export const CardBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`

export const CardContent = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  padding-left: 10px;
  padding-right: 10px;
`

export const CardTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`

export const CardDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  position: absolute;
  left: 0;
  bottom: 35px;

  padding-left: 35px;
  padding-right: 35px;

  ${({ theme }) => '@media ' + theme.mediaQueries.mobile} {
    bottom: 20px;

    padding-left: 20px;
    padding-right: 20px;
  }
`
